import { Reference } from '@approvalmax/types';
import { useSelector } from 'modules/react-redux';
import { getNetSuiteContext } from 'pages/requestForm/selectors/netsuite/netSuiteSelectors';
import { useMemo } from 'react';

export const useCurrencyPrecision = (currency: Reference | null | undefined) => {
    const { currencies } = useSelector(getNetSuiteContext);

    return useMemo(() => currencies.find(({ id }) => id === currency?.id)?.precision ?? 2, [currency, currencies]);
};
